module.exports = __webpack_public_path__ + "120158735067c39624c023f4e28237bd.svg";